<template>
  <div class="customer-type-tabs" role="tablist">
    <button
      v-for="item in options"
      :key="item.value"
      :aria-selected="tabsValue === item.value"
      class="customer-type-tabs__item"
      :class="{ 'is-active': tabsValue === item.value }"
      role="tab"
      type="button"
      @click="handleChange(item.value)"
    >
      <!-- 默认按 options[].icon 渲染图标类名；需要自定义节点时用 icon 插槽覆盖 -->
      <slot :item="item" name="icon">
        <i
          v-if="item.icon"
          aria-hidden="true"
          class="customer-type-tabs__icon t-iconfont"
          :class="item.icon"
        ></i>
      </slot>
      {{ item.label }}
    </button>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

defineProps({
  options: {
    type: Array,
    default: () => []
  }
})

const tabsValue = defineModel({
  type: [String, Number],
  default: ''
})

const handleChange = (val) => {
  tabsValue.value = val
}
</script>

<style lang="less" scoped>
.customer-type-tabs {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  box-sizing: border-box;
  height: 32px;
  padding: 2px;
  background: #f2f3f5; // 填充/Fill-2 一般 常规 白底悬浮
  border-radius: 10px;

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 28px;
    padding: 4px 12px;
    gap: 8px;
    color: #969799; // 文字/Text-2 次要信息
    font-size: 14px; // 四级文字/常规
    font-weight: 400;
    font-family: inherit;
    line-height: 20px;
    white-space: nowrap;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;

    &.is-active {
      color: #323233; // 文字/Text-4 强调正文标题
      background: #ffffff; // 填充/纯白
    }
  }

  &__icon {
    flex-shrink: 0;
    line-height: 1;
  }
}
</style>
